import '../style.scss';
import template from './subscriptionBrokerPediaModal.html';
import controller from '../subscriptionModalCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    subscriptionData: '<',
    orderedById: '<',
  },
};
